import { analyticsContext } from './analytics-context';
import { type CanvasAnalyticsWebClient } from './analytics-web-client';

export type TrackAnalyticsEvent = Parameters<
  CanvasAnalyticsWebClient['sendTrackEvent']
>[0];

export const fireTrackEvent = async (event: TrackAnalyticsEvent) => {
  if (!analyticsContext.client) {
    return;
  }

  try {
    await analyticsContext.client.sendTrackEvent(event);
  } catch (e) {
    console.error(e);
  }
};

// TODO - Refactor this, now that analytics client is initialised synchronously
// at the start of our app we can likely move away from these hooks and use
// `analyticsContext.client` directly
export const useFireTrackEvent = (): {
  fireTrackEvent: (event: TrackAnalyticsEvent) => Promise<void>;
} => {
  return { fireTrackEvent };
};
